export default "__VITE_ASSET__CeShih0u__"